import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
import { CookieService } from 'ngx-cookie-service';
import { CurrentUserService } from './currentuser.service';
import { ICurrentUserModel } from '@models/auth/auth.model';

@Injectable({ providedIn: 'root' })
export class HttpHeaderService {
  constructor(
    private storageService: StorageService,
    private cookieService: CookieService,
    private currentuserService: CurrentUserService
  ) {}
  async get(): Promise<HttpHeaders> {
    const currentUser: ICurrentUserModel =
      await this.currentuserService.getAsync();
  
    if (currentUser?.jwtToken) {
      return new HttpHeaders({
        authorization: `Bearer ${currentUser.jwtToken}`,
      });
    }
  
      return new HttpHeaders({
        'Content-Type': 'application/json',
      });
  }
}
